import RestClientService from "@/core/services/restClient.service";
import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";
import {
  DUPLICATE_BOOKINGS_API_PATH,
  DuplicateBookingsQueryPayload,
} from "../constants";
import { DuplicateBookingRecord } from "../interfaces/duplicateBookingsResponse.interface";

class DuplicateBookingsService {
  private restClient: RestClientService;

  constructor() {
    this.restClient = new RestClientService();
  }

  public fetchDuplicateBookings(
    params: DuplicateBookingsQueryPayload,
  ): Promise<ICoreResponse<DuplicateBookingRecord[] | null>> {
    return this.restClient.get(DUPLICATE_BOOKINGS_API_PATH.LIST, params);
  }
}

export default DuplicateBookingsService;
